<template>
  <div class="head-btn-group">
    <el-button v-for="item in inGateIdTabs" :key="item.Id"  type="text" :class="{active : gateId === item.Id}" @click="setValue(item)">
      <el-badge is-dot :hidden="item.hidden" class="item">{{item.Name}}</el-badge>
    </el-button>
    <el-button v-for="item in leftGateIdTabs" :key="item.Id"  type="text" :class="{active : gateId === item.Id}" @click="setValue(item)">
      <el-badge is-dot :hidden="item.hidden" class="item">{{item.Name}}</el-badge>
    </el-button>
  </div>
</template>

<script>
// import park from '../'
export default {
  data: () => ({
  }),
  props: {
    showPassIn: Boolean
  },
  computed: {
    gateId: function () {
      return parseInt(this.$store.state.order.tabsGateId)
    },
    leftGateIdTabs: function () {
      return JSON.parse(this.$store.state.order.leftGateIdTabs)
    },
    inGateIdTabs: function () {
      return this.showPassIn ? JSON.parse(this.$store.state.order.inGateIdTabs) : []
    },
    changeDot: function () {
      let arr = this.inGateIdTabs.filter(v => {
        return !v.hidden
      });
      let arr02 = this.leftGateIdTabs.filter(v => {
        return !v.hidden
      });
      return arr.concat(arr02)
    }
  },
  watch: {
    changeDot() {
      // console.log(v, this.inGateIdTabs, this.$store.state.order.inGateIdTabs)
      this.$forceUpdate();
    }
  },
  mounted() {
    // if (this.gateArrStr && this.gateArrStr.length > 0) this.gateArr = JSON.parse(this.gateArrStr);
    // console.log('tabs', this.gateId)
    // console.log(this.showPassIn)
  },
  methods: {
    setValue(data) {
      this.$emit("change", data);
    },
  },
};
</script>

<style lang="scss">
  .head-btn-group{
    text-align: left;
    background: #fff;
    padding-bottom: 10px;
    .el-button--text{
      color: #303133;
      border-radius: 0;
      border-bottom: 2px solid transparent;
      padding: 9px 0px!important;
      margin: 0 11px;
      font-size: 16px;
    }
    .el-button--text.active{
      color: #0178EC;
      border-bottom-color: #0178EC;
    }
  }
</style>
